<template>
  <div>
    <app-nav></app-nav>
    <div class="col-xs-12.col-sm-4 offset-1">
      <h4> Nouveau contrat d'intérim</h4>
    
      <router-link to="/contrats_interim" class="btn btn-primary"> Retour vers la liste</router-link>
      <p class="lead"></p>
    </div>
    <div class="row">
      <div class="col-5 offset-1">
        <p class="bg-danger" v-if="message">{{message.message}}</p>
        <form v-on:submit.prevent class="contrat-form mp-4">
          <select id="interimaire" name="interimaire" type="text" class="form-control" v-on:change="sourceChanged" required>
            <option value="" selected data-default>Choisir l'iade remplaçant(e) (à créer si besoin)</option>
            <option 
              v-bind:value="interimaire.id" v-bind:key="interimaire.id" v-for="interimaire in allInterimaires.nodes"> {{interimaire.prenom +' '+interimaire.nom}} </option>
          </select>
          <select id="iade" name="iade" type="text" class="form-control" v-on:change="sourceChangedIADE" required>
            <option value="" selected data-default>Choisir l'iade remplacé(e)</option>
            <option 
              v-bind:value="iade.id" v-bind:key="iade.id" v-for="iade in allIades.nodes"> {{iade.prenom +' '+iade.nom}} </option>
          </select>
          <select  name="raison" id="raison" class="form-control" type="text" v-model="raison">
            <option value="" selected data-default>Choisir un motif</option>
            <option value="congés payés">Congés payés</option>
            <option value="maladie">Maladie</option>
            <option value="formation">Formation</option>
          </select>
          <datetime 
            input-class="form-control"
            v-model="dateDebut"
            type="datetime"
            placeholder="Date et heure de début du remplacement"
            zone="local"
            value-zone="local"
            minute-step="30"
            ></datetime>
          <datetime 
            input-class="form-control"
            v-model="dateFin"
            type="datetime"
            placeholder="Date et heure de fin"
            zone="local"
            value-zone="local"
            minute-step="30"
            ></datetime>
          <input type="text"  class="form-control" name="taux-brut" id="" v-model="tauxBrut" placeholder="Taux horaire brut (29.00 par défaut)">
          <input type="submit" value="Valider" class="btn btn-primary btn-block" @click.stop="addContrat" />
        </form>
      </div>
      <div class="col-5 augmented">
        <h4>Les régles:</h4>
        <p>Contrats de 1 ou plusieurs jours, indiquer le jour et l'heure de début et 
        <br>
        le jour et l'heure de fin.
        <br>
        Faire plusieurs contrats si les iades remplacé(e)s sont différent(e)s !
        <br>
        On peut maintenant choisir un taux horaire brut (par défaut 29.00 €).
        <br>
        Bien archiver les contrats papiers signés (pas encore de signature électronique) !!!
        <br>
        En cas de difficultés avec les contrats, votre interlocuteur chez InExtenso est Rachel Corradi
        rachel.corradi@inextenso.fr
        <br>
        Demandez moi les modifications/améliorations que vous souhaitez.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  import AppNav from '../AppNav'
  import moment from 'moment'
  import { CONTRATS_PER_PAGE } from '../../constants/settings'
  import {
    ALL_ACTIVES_INTERIMS,
  } from '../../constants/interim'
  import {
    ALL_ACTIVES_IADES,
  } from '../../constants/iade'
  import {
    CREATE_CONTRAT,
    ALL_CONTRATS
  } from "../../constants/contratsInterim"

  export default {
    name: "contratsInterimNew",
    components: {
      AppNav
    },
    data() {
      return {
        moment: moment,
        allInterimaires: {},
        allIades: {},
        interimaire: null,
        iade: null,
        raison: '',
        dateDebut: null,
        dateFin: null,
        tauxBrut: null,
        message: ''
      }
    },
    apollo: {
      allInterimaires: {
        query: ALL_ACTIVES_INTERIMS
      },
      allIades: {
        query: ALL_ACTIVES_IADES
      }
    },
    methods: {
      sourceChanged: function (e) {
        for (var i = 0; i < this.allInterimaires.nodes.length; i++) {
          if (this.allInterimaires.nodes[i].id == e.target.value) {
            this.interimaire = this.allInterimaires.nodes[i];
          }
        }
        this.$emit("sourceChanged", e.target.value);
      },
      sourceChangedIADE: function (e) {
        console.log(this)
        for (var i = 0; i < this.allIades.nodes.length; i++) {
          if (this.allIades.nodes[i].id == e.target.value) {
            this.iade = this.allIades.nodes[i];
          }
        }
        this.$emit("sourceChangedIADE", e.target.value);
      },
      addContrat: function () {
        const interimaire = this.interimaire
        const iade = this.iade
        const raison = this.raison
        const dateDebut = this.dateDebut
        const dateFin = this.dateFin
        const tauxBrut = this.tauxBrut
        var self = this
        this.$apollo
          .mutate({
            mutation: CREATE_CONTRAT,
            variables: {
              interimaireId: this.interimaire.id,
              iadeId: this.iade.id,
              raison: this.raison,
              dateDebut: this.dateDebut,
              dateFin: this.dateFin,
              tauxBrut: this.tauxBrut
            },
            refetchQueries: [{
              query: ALL_CONTRATS,
                variables: {
            offset: 0,
            first: CONTRATS_PER_PAGE
        }
            }]
          })
          .then(function (data) {
            self.$router.push({
              name: 'ContratsInterim'
            })
          })
          .catch(function (error) {
            console.error("error", error)
            self.message = error
            // We restore the initial user input
          })
      }
    }
  }
</script>
<style scoped>
  body {
    padding-top: 3.5rem;
  }

  h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
  }

  .sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
  }

  .sidebar {
    padding-left: 0;
    padding-right: 0;
  }

  .sidebar .nav {
    margin-bottom: 20px;
  }

  .sidebar .nav-item {
    width: 100%;
  }

  .sidebar .nav-item+.nav-item {
    margin-left: 0;
  }

  .sidebar .nav-link {
    border-radius: 0;
  }

  .placeholders {
    padding-bottom: 3rem;
  }

  .placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  /* select option[data-default] {
    display: none;
  } */

  .medecins-form {
    padding-bottom: 60px;
  }
  .augmented {
    font-size: larger;
  }
</style>



// WEBPACK FOOTER //
// contratNew.vue?297f3eae